import {useEffect} from "react";
import auth from "../api/auth";

const Home = () => {

    useEffect(() => {
        auth.hasSession().then((session) => {
            if (!session) window.location.assign("/logout");
        });
    }, [])

    return (
        <>
            <div className="home page-title">
                <div>Home</div>
            </div>
            <div className="home-page-description">
                <div>Welcome to the CCMI Admin Portal</div>
            </div>
        </>
    )
}

export default Home